module.exports = __webpack_public_path__ + "img/choose-up-Up Dejun.d0baf344.png";